import { createApiClient } from '../shared/http/ApiClient.js';
import type { RouteLoader } from '../shared/ssr/RouteLoader.js';
import { headDeHome } from './home.head.js';
import { HomeRepository } from './models/repositories/HomeRepository.js';
import type { HomeData } from './models/entities/HomeData.js';
import { CACHE_TAG } from '@ahora-patagonia/contracts';

export const HOME_ROUTE_KEY = 'home';

/**
 * Loader de la portada: resuelve la home entera en el server (bloques + shell + avisos con
 * sus altos ya decididos), arma el `<head>` y declara la política de caché. La hidratación
 * no vuelve a pedir nada.
 */
export const homeLoader: RouteLoader<HomeData> = async (ctx) => {
  const api = createApiClient({
    baseUrl: process.env['SSR_API_URL'] ?? 'http://localhost:3000',
    headers: { host: ctx.headers['host'] ?? '' },
  });
  const data = await new HomeRepository(api).home();

  return {
    data,
    head: headDeHome(ctx.site),
    cache: {
      sMaxAge: 60,
      staleWhileRevalidate: 300,
      // `shell` y `ads` además del propio: la cabecera con el menú de secciones y los avisos se
      // dibujan en toda página, así que renombrar una sección o pausar una campaña tienen que
      // poder purgar esta también. Son los mismos tags que emite la API (`PUBLIC_CACHE_TAGS`):
      // si acá faltara uno, la purga limpiaría la API y el sitio seguiría sirviendo el HTML viejo.
      tags: [CACHE_TAG.home, CACHE_TAG.shell, CACHE_TAG.ads],
      visibility: 'public',
    },
  };
};
